type FileObject = {
    _id?: string;
    path?: string;
    file?: string;
    fileUrl?: string;
    mimetype?: string;
    storageType?: string;
};

export function getNormalizeFileUrl(fileObj: FileObject | null | undefined, fallback: string = ''): string {
    
    if (fileObj?.storageType && (fileObj?.storageType === 'awss3Bucket' || fileObj?.storageType === 'azureBlobStorage')) {
        return fileObj.fileUrl || fileObj.path || fallback;
    } else if (fileObj?.path) {
        return process.env.REACT_APP_FILE_URL + fileObj.path;
    }

    if (fileObj?.file && fileObj?.mimetype) {
        return `data:${fileObj.mimetype};base64,${fileObj.file}`;
    }

    return fallback;
}
